const getArrayPositionsWordInText = (text, string) => {
  return [...text.matchAll(new RegExp(string, "gi"))].map((a) => a.index);
};

export { getArrayPositionsWordInText };
